import { cn } from "@/lib/utils";
import React from "react";

export const BentoGrid = ({
  className,
  children,
}: {
  className?: string;
  children?: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        "mx-auto grid max-w-7xl grid-cols-1 gap-6 md:auto-rows-[18rem] md:grid-cols-4 lg:grid-cols-4",
        className,
      )}
    >
      {children}
    </div>
  );
};

export const BentoGridItem = ({
  className,
  title,
  description,
  header,
  icon,
  children,
  glowColor = "#00F5A0",
}: {
  className?: string;
  title?: string | React.ReactNode;
  description?: string | React.ReactNode;
  header?: React.ReactNode;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  glowColor?: string;
}) => {
  return (
    <div
      className={cn(
        "group/bento row-span-1 flex flex-col justify-between space-y-4 rounded-xl border border-[#00F5A0]/20 bg-[#0A0F0D]/80 backdrop-blur-xl p-6 transition-all duration-300 hover:shadow-xl hover:shadow-[#00F5A0]/10 hover:border-[#00F5A0]/40 hover:bg-[#0A0F0D]/90",
        className,
      )}
      style={{
        boxShadow: `0 0 20px ${glowColor}20, inset 0 1px 0 ${glowColor}20`,
      }}
    >
      {header}
      <div className="transition-all duration-300 group-hover/bento:translate-x-2">
        {icon && (
          <div className="flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-r from-[#00F5A0]/20 to-[#0AEFFF]/20 border border-[#00F5A0]/30 mb-4 group-hover/bento:scale-110 transition-transform duration-300">
            {icon}
          </div>
        )}
        {title && (
          <div className="mb-2 font-bold text-lg text-[#F3F6FA] group-hover/bento:text-[#00F5A0] transition-colors duration-300">
            {title}
          </div>
        )}
        {description && (
          <div className="font-medium text-sm text-[#F3F6FA]/70 leading-relaxed">
            {description}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};